// SMS encoding maths, shared by every surface that types an SMS (broadcast compose and the
// conversation composer) so the character budget and cost estimate agree wherever they are shown.

// One GSM-7 segment. Longer messages still send; they just cost more than one segment.
export const SMS_MAX_CHARS = 160;

// Approx AUD per segment for cost estimates (Telnyx AU long code ~US$0.05 => ~A$0.07). Estimate only:
// actual Telnyx billing may differ.
export const SMS_RATE_AUD = 0.07;

// GSM 03.38 default alphabet + extension chars. A body using only these encodes as GSM-7 (160 chars for
// one segment, then 153/segment); anything else (emoji, curly quotes, en dash) forces UCS-2 (70, then 67).
const GSM7_CHARS =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ ÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^{}\\[~]|€';

export const isGsm7 = (text) => [...String(text || '')].every((ch) => GSM7_CHARS.includes(ch));

/** Segments a message occupies, accounting for encoding so emoji/Unicode are not undercounted. */
export const smsSegments = (text) => {
  const len = String(text || '').length;
  if (len === 0) return 0;
  const [single, multi] = isGsm7(text) ? [160, 153] : [70, 67];
  return len <= single ? 1 : Math.ceil(len / multi);
};

/** Estimated AUD cost of sending `text` to `recipientCount` recipients. */
export const estimateSmsCost = (text, recipientCount) => smsSegments(text) * recipientCount * SMS_RATE_AUD;
